import React, { useState } from "react";

import { Card, Pagination, Table, Popconfirm, message } from "antd";

import { useParams } from "react-router-dom";

import { Tag, Tooltip, Space, Tabs } from "antd";
import {
  CheckCircleOutlined,
  PlayCircleOutlined,
  UserAddOutlined,
  BarsOutlined,
  CheckOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";
import { capitalizeWords } from "../../../../components/icons/ApplicationColor";
import { DeleteTwoTone } from "@ant-design/icons";

import useCommonListing from "../../../../components/AdminComponents/customHooks/useCommonListing";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import axiosInstance from "../../../../api/Axios";
import AddEditUsers from "../../../../components/AdminComponents/Modals/AddEditUsers";
import EditableImage from "../../../../components/icons/EditIcon";
import UploadManager from "./UploadManager";
import UploadInterface from "./UploadInterface";
// import UploadInterface from "./UploadInterface";
// import UploadSection from "./UploadSection";
// import { GetFormattedDateTime } from "../../../../components/utils/DateTimeUtils";

import UploadDetails from "./UploadDetails";

const { TabPane } = Tabs;
const Users = (props) => {
  // eslint-disable-next-line no-unused-vars
  const userInfo = useSelector((state) => state.user);
  const classification = useSelector(
    (state) => state.orgdeatil.customerClassification
  );
  const { id } = useParams();
  const [loadAgain, setLoadAgain] = useState(false);
  const [current, setCurrent] = useState("upload");
  const [uploadId, setUploadId] = useState(null);
  const LoadAPI = () => {
    setLoadAgain((prev) => !prev);
  };
  const [messageApi, contextHolder] = message.useMessage();
  const {
    data,
    itemsLength,
    loading,
    filterData,
    onShowSizeChange,
    onPageChange,
    handleSearchChange,
    // setFilterData,
    // handleSwitchChange,
    // handleClearAll,
    // setFilterUrl,
  } = useCommonListing({
    userInfo,
    passSize: 10,
    passPage: 1,
    passURL: `/customer/userlist/?organization_id=${id}`,
    loadAgain: loadAgain,
  });
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, active, filter_url } = filterData;

  // Commented out - Contacts section removed
  // const {
  //   data: data2,
  //   itemsLength: itemsLength2,
  //   loading: loading2,
  //   filterData: filterData2,
  //   onShowSizeChange: onShowSizeChange2,
  //   onPageChange: onPageChange2,
  //   handleSearchChange: handleSearchChange2,
  //   // setFilterData,
  //   // handleSwitchChange,
  //   // handleClearAll,
  //   // setFilterUrl,
  // } = useCommonListing({
  //   passSize: 10,
  //   passPage: 1,
  //   passURL: `/customer/userlist/?organization_id=${id}&is_contact=True`,
  //   loadAgain: loadAgain,
  // });
  // // eslint-disable-next-line no-unused-vars
  // const {
  //   pageSize: pageSize2,
  //   currentPage: currentPage2,
  //   // eslint-disable-next-line no-unused-vars
  //   active: active2,
  //   // eslint-disable-next-line no-unused-vars
  //   filter_url: filter_url2,
  // } = filterData2;

  const DeleteSuccessfull = () => {
    messageApi.open({
      type: "success",
      content: "User has been removed successfully.",
      duration: 5,
    });
    props?.LoadUser();
    LoadAPI();
  };
  const DeleteFalied = () => {
    messageApi.open({
      type: "error",
      content: "Failed to remove User.",
      duration: 5,
    });
  };
  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const [visible, setVisible] = useState(false);
  const [editData, setEditData] = useState();
  const [isEditing, setIsEditing] = useState(false);
  const handleCancel = () => {
    setVisible(false);
    setEditData(null);
    setIsEditing(false);
    setView("list");
  };
  const handleRowClick = (record) => {
    console.log(record);
    setEditData(record);
    setIsEditing(true);
    setVisible(true);
    setView("form");
  };
  // existing props/state...
  const [isContact, setIsContact] = useState(false); // defaultActiveKey = "otherUsers" (Users tab)
  const [view, setView] = useState("list"); // 'list' or 'form'

  const handleTabChange = (activeKey) => {
    // when activeKey is "contact" mark true, otherwise false
    setIsContact(activeKey === "contact");
    // when activeKey is "upload" set current to "upload"
    if (activeKey === "upload") {
      setCurrent("upload");
    }
  };
  const handleDelete = async (record) => {
    if (false) {
      try {
        await axiosInstance.delete(
          `/learn/bundleuserdelete/${record?.bundle_course_id}/${record?.user_id}/`,
          {
            headers: {
              "X-CSRFToken": csrfToken,
            },
          }
        );
        DeleteSuccessfull();
      } catch (err) {
        DeleteFalied();
      }
    }
  };
  const CreateSuccessfull = (text) => {
    messageApi.open({
      type: "success",
      content: `User has been ${text}.`,
      duration: 5,
    });
    LoadAPI();
    props?.LoadUser();
    setView("list");
  };

  const CreateFailed = (props) => {
    messageApi.open({
      type: "error",
      content: `User has not been ${props}.`,
      duration: 5,
    });
  };
  const columns = [
    {
      title: "User ID",
      dataIndex: "employee_id",
      key: "employee_id",
      width: 135,
    },
    {
      title: "User Name",
      dataIndex: "full_name",
      key: "full_name",
      width: 140,
      render: (text, record) => (
        <div>
          {record?.first_name} {record?.last_name}
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 200,
    },
    ...(false
      ? [
        {
          title: "Progress Summary",
          key: "progress_summary",
          render: (text, record) => {
            const {
              completed_count,
              enroled_count,
              started_count,
              total_count,
            } = record;

            return (
              <Space size="small" direction="vertical">
                <Space wrap>
                  <Tooltip title="Total Assigned">
                    <Tag
                      icon={<BarsOutlined />}
                      color="default"
                      style={{ fontSize: "13.25px" }}
                    >
                      {total_count}
                    </Tag>
                  </Tooltip>
                  <Tooltip title="Enrolled">
                    <Tag
                      icon={<UserAddOutlined style={{ color: "blue" }} />}
                      color="default"
                      style={{ fontSize: "13.25px" }}
                    >
                      {" "}
                      {enroled_count}
                    </Tag>
                  </Tooltip>
                  <Tooltip title="Started">
                    <Tag
                      icon={
                        <PlayCircleOutlined style={{ color: "#ec7a1c" }} />
                      }
                      color="default"
                      style={{ fontSize: "13.25px" }}
                    >
                      {" "}
                      {started_count}
                    </Tag>
                  </Tooltip>
                  <Tooltip title="Completed">
                    <Tag
                      icon={
                        <CheckCircleOutlined style={{ color: "green" }} />
                      }
                      color="default"
                      style={{ fontSize: "13.25px" }}
                    >
                      {" "}
                      {completed_count}
                    </Tag>
                  </Tooltip>
                </Space>
              </Space>
            );
          },
          width: 280,
        },
      ]
      : []),
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
      width: 180,
    },
    {
      title: "Department",
      dataIndex: "department_name",
      key: "department_name",
      width: 250,
      ellipsis: true,
      render: (text, record) => (
        <div>{record?.organization?.department?.dep_name || ""}</div>
      ),
    },
    {
      title: "Contact",
      dataIndex: "is_contact",
      key: "is_contact",
      width: 100,
      align: "center",
      render: (text, record) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          {record?.is_contact ? (
            <CheckOutlined style={{ color: "#52c41a", fontSize: "18px" }} />
          ) : (
            <CloseOutlined style={{ color: "#ff4d4f", fontSize: "18px" }} />
          )}
        </div>
      ),
    },
    {
      title: "Verified",
      dataIndex: "is_verified",
      key: "is_verified",
      width: 100,
      align: "center",
      render: (text, record) => (
        <div style={{ display: "flex", justifyContent: "center" }}>
          {record?.is_verified ? (
            <CheckOutlined style={{ color: "#52c41a", fontSize: "18px" }} />
          ) : (
            <CloseOutlined style={{ color: "#ff4d4f", fontSize: "18px" }} />
          )}
        </div>
      ),
    },

    ...(true
      ? [
        {
          title: "Actions",
          dataIndex: "id",
          key: "id",
          align: "center",
          width: 100,
          fixed: "right",
          render: (text, record) => (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <EditableImage
                handleRowClick={() => handleRowClick(record)}
                recordId={record}
                passSize="small"
              />
              <Popconfirm
                title={"Delete User"}
                description=" "
                onConfirm={() => handleDelete(record)}
                // onCancel={cancel}
                okText="Yes"
                cancelText="No"
                placement="leftTop"
              >
                <DeleteTwoTone
                  style={{
                    cursor: "pointer",
                    fontSize: "1.6rem",
                    marginLeft: "0.7rem",
                  }}
                  title="Archive"
                  twoToneColor="#eb2f96"
                />
              </Popconfirm>
            </div>
          ),
        },
      ]
      : []),
  ];
  //   const { data: data2 } = useCommonListing({
  //     passSize: 100,
  //     passPage: 1,
  //     passURL: `learn/bundledetailslist/?bundle_id=${id}`,
  //   });
  //   console.log(data2);
  const TableBlock = ({ isContact }) => (
    <>
      <CommonTopDetails
        title={
          !isContact
            ? `${classification ? capitalizeWords(classification) : "Customer"} Users`
            : `${classification ? capitalizeWords(classification) : "Customer"} Contacts`
        }
        titleSuffix={`${itemsLength || 0} user(s)`}
        searchPlaceholder="Search by..."
        searchValue={filterData.search}
        searchAction={handleSearchChange}
        showAddButton={props?.ImpersonateAccess}
        filterAction={false}
        marginPass="15px"
        paddingInlinepass="10px"
        topSizeAdd="5px"
        addButtonProps={{
          modalType: "PopUP",
          modalProps: () => {
            setVisible((prev) => !prev);
            setIsEditing(false);
            setView("form");
          },
        }}
      />
      <>
        {" "}
        <Table
          columns={columns}
          dataSource={data}
          rowKey="id"
          size="small"
          loading={loading}
          className="table-container"
          style={{ margin: "1rem" }}
          pagination={false}
          scroll={{ x: 400 }}
          bordered
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "1rem",
          }}
        >
          <Pagination
            size="small"
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            onChange={onPageChange}
            pageSizeOptions={["5", "10", "15", "20", "50"]}
            current={currentPage}
            defaultPageSize={pageSize}
            total={itemsLength}
          />
        </div>
      </>
      {/* ) : (
        <>
          {" "}
          <Table
            columns={columns}
            dataSource={data2}
            rowKey="id"
            size="small"
            loading={loading2}
            className="table-container"
            style={{ margin: "1rem" }}
            pagination={false}
            scroll={{ x: 400 }}
            bordered
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "1rem",
            }}
          >
            <Pagination
              size="small"
              showSizeChanger
              onShowSizeChange={onShowSizeChange2}
              onChange={onPageChange2}
              pageSizeOptions={["5", "10", "15", "20", "50"]}
              current={currentPage2}
              defaultPageSize={pageSize2}
              total={itemsLength2}
            />
          </div>
        </>
      )} */}
    </>
  );
  console.log(current);
  return (
    <Card style={{ width: "100%", marginBottom: "10px" }} hoverable>
      {contextHolder}
      {/* <Title level={5} style={{ marginInline: "10px" }}>
        Associated Users Summary
      </Title> */}
      {view === "list" ? (
        <Tabs
          defaultActiveKey="otherUsers"
          style={{ marginInline: "10px" }}
          onChange={handleTabChange}
        >
          {/* Commented out - Contacts section tab removed */}
          {/* <TabPane tab="Contacts" key="contact">
          <TableBlock isContact={true} />
        </TabPane> */}

          <TabPane tab="Users" key="otherUsers">
            <TableBlock isContact={false} />
          </TabPane>
          <TabPane tab="User Uploads" key="upload">
            {current === "upload" && (
              <UploadManager
                {...props}
                current={current}
                setCurrent={setCurrent}
                setUploadId={setUploadId}
              />
            )}
            {current === "excel" && (
              <UploadInterface
                {...props}
                current={current}
                setCurrent={setCurrent}
                setUploadId={setUploadId}
              />
            )}
            {current === "upload_details" && (
              <UploadDetails
                {...props}
                current={current}
                setCurrent={setCurrent}
                uploadId={uploadId}
                id={id}
              />
            )}
          </TabPane>
        </Tabs>
      ) : (
        <AddEditUsers
          key={editData?.id || "new-role"}
          visible={visible}
          modalData={editData}
          onCancel={handleCancel}
          CreateSuccessfull={CreateSuccessfull}
          CreateFailed={CreateFailed}
          id={id}
          edit={isEditing}
          isContact={isContact}
        />
      )}
    </Card>
  );
};

export default Users;
